/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData, AppContext } from 'commons-ui';
import _get from 'lodash/get';
import { Experiment } from './types';
import { CREATE_AB_TEST_ENDPOINT } from './constants';

const useService = () => {
	const { postData, getData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);

	const { isGold, appName } = app;

	const getAllExperiments = useCallback(
		async ({
			pageDetails,
			sortDetails,
			filterDetails,
			searchText
		}: {
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
			searchText: string;
		}) => {
			const result = await postData({
				endpoint: '/marketing/dashboard/abTest/getExperiments',
				queryParams: {
					appName,
					searchText
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				}
			});

			const data = _get(result, ['data', 'result'], []);

			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	const getAllExperimentVersion = useCallback(async ({ abTestId }) => {
		const result = await getData({
			endpoint: '/marketing/dashboard/abTest/getExperimentVersions',
			queryParams: {
				appName,
				abTestId
			}
		});

		const data = _get(result, ['data', 'data'], []);
		return data;
	}, []);

	const requestEditExperiment = useCallback((expData: Experiment) => {
		return postData({
			endpoint: '/marketing/dashboard/abTest/updateExperiment',
			body: { ...expData },
			queryParams: {
				appName,
				expName: expData.name
			}
		});
	}, []);

	const requestCreateExperiment = useCallback((expData: Experiment) => {
		return postData({
			endpoint: CREATE_AB_TEST_ENDPOINT,
			body: { ...expData },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestRevertExperiment = useCallback(({ versionId, abTestId }) => {
		return postData({
			endpoint: '/marketing/dashboard/abTest/revertExperimentToVersion',
			body: { versionId, abTestId },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestFixUserBucket = useCallback(({ userId, bucketId, name }) => {
		return postData({
			endpoint: '/marketing/dashboard/abTest/fixUsersBucket',
			body: {
				fixBuckets: `${userId}=${bucketId}`
			},
			queryParams: {
				appName,
				expName: name
			}
		});
	}, []);

	const requestFindUserBucket = useCallback(({ userId, experimentName }) => {
		return postData({
			endpoint: '/marketing/dashboard/abTest/findUserBucket',
			body: {
				uid: userId
			},
			queryParams: {
				appName,
				expName: experimentName
			}
		});
	}, []);

	return {
		getAllExperiments,
		requestEditExperiment,
		getAllExperimentVersion,
		requestRevertExperiment,
		requestFixUserBucket,
		requestFindUserBucket,
		requestCreateExperiment
	};
};

export default useService;
